import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FiUsers, FiShield, FiHeart, FiXCircle } from 'react-icons/fi';

const CommunityGuidelines = () => {
  const guidelines = [
    { 
      title: "Be Respectful", 
      icon: <FiHeart className="text-red-500" size={24} />, 
      desc: "Treat all players with respect, regardless of skill level, background, or identity. We have zero tolerance for harassment or hate speech." 
    },
    { 
      title: "Play Fair", 
      icon: <FiShield className="text-red-500" size={24} />, 
      desc: "Honesty is key in sports. Don't misrepresent your skill level or cheat during games. Maintain the spirit of fair play." 
    },
    { 
      title: "Show Up", 
      icon: <FiUsers className="text-red-500" size={24} />, 
      desc: "If you join a match, show up on time. Repeated no-shows affect the experience for everyone and may lead to account restrictions." 
    },
    { 
      title: "No Toxicity", 
      icon: <FiXCircle className="text-red-500" size={24} />, 
      desc: "Avoid aggressive behavior, bullying, or creating a hostile environment in match chats or on the field." 
    }
  ];

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-white mb-4">Community Guidelines</h1>
        <p className="text-gray-400 mb-12">Building a safe and enjoyable sports community for Dhaka.</p>

        <div className="grid gap-8">
          {guidelines.map((g, i) => (
            <div key={i} className="bg-gray-900 p-8 rounded-2xl border border-gray-800 flex gap-6">
              <div className="mt-1">{g.icon}</div>
              <div>
                <h3 className="text-xl font-bold text-white mb-2">{g.title}</h3>
                <p className="text-gray-400 leading-relaxed text-sm">{g.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 bg-red-500/10 border border-red-500/20 rounded-2xl">
          <h4 className="text-red-500 font-bold mb-2">Enforcement</h4>
          <p className="text-gray-300 text-sm">
            Violations of these guidelines can result in warnings, temporary suspensions, or permanent bans from the PlayConnect platform.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CommunityGuidelines;
